import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import io from "socket.io-client";
import { SOCKET_URL } from "constants/env";
import { addOneNotification } from "store/actions/notifications";

const useNotificationSocket = (userId) => {
  const dispatch = useDispatch();
  const socketRef = useRef(null);

  useEffect(() => {
    if (!userId) return;

    const socket = io(`${SOCKET_URL}?path=notification&userId=${userId}`);
    socketRef.current = socket;

    socket.on("notification", (data) => {
      dispatch(addOneNotification(data));
    });

    return () => {
      socket.disconnect();
      socketRef.current = null;
    };
  }, [userId]);
};

export default useNotificationSocket;
